<div class="modal-content">
  <div id="edit-report">
    <div class="modal-header">
      <h1 class="modal-title" ngbAutofocus tabindex="-1">
        <ng-container [ngSwitch]="ReportType[reportForm.get('reportType').value]" *ngIf="isCreationMode; else editModeTitle">
          <ng-container *ngSwitchCase="ReportType[ReportType.P]">
            Add Purchase Report
          </ng-container>
          <ng-container *ngSwitchCase="ReportType[ReportType.PAQ]">
            Add Purchase-AQ Report
          </ng-container>
          <ng-container *ngSwitchDefault>
            Add Report
          </ng-container>
        </ng-container>
        <ng-template #editModeTitle>
          <span *ngIf="purchaseReport.reportType === ReportType.PAQ">Aquarium </span>
          Dealer Purchase Receipt Report for {{purchaseReport.reportDate.toDate() | date:'longDate'}}
        </ng-template>
      </h1>
    </div>
    <form [formGroup]="reportForm" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="row mb-2">
          <div class="col-md-12">
            <div>All fields are required unless marked optional.</div>
          </div>
        </div>
        <div class="row" [ngClass]="{'disabled-input' : duplicatesChecking || statusChecking }">
          <div class="col-md-4">
            <div class="form-group">
              <app-autocomplete-input
                formControlName="seller"
                (itemSelect)="onSellerSelect($event)"
                (focusin)="selectOnFocus($event)"
                (focusOut)="onSellerEnter($event)"
                [id]="'commId'"
                [title]="'Comm. Marine Lic. #'"
                [editable]="false"
                [aria-label]="'commId'"
                [autocomplete]="licenseAutocomplete"
                [inputFormatter]="licenseAutocompleteFormatter"
                [resultFormatter]="licenseAutocompleteFormatter"
                [isInvalid]="hasError('seller')">
              </app-autocomplete-input>
              <div *ngIf="hasError('seller', 'required')" role="alert" class="formError text-danger" aria-live="assertive">
                Please, select correct Commercial Marine License number.
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <ng-container *ngIf="period; else purchase_date_picker">
                <label for="purchaseDate">Purchase Date</label>
                <select class="form-control required" aria-required="true" id="purchaseDate" formControlName="reportDate" [ngClass]="{'is-invalid': hasError('reportDate')}">
                  <option value="">-- Select a Date --</option>
                  <ng-container  *ngFor="let day of days">
                  <option *ngIf="day < today" [value]="day | date:'yyyy-MM-dd'">{{day | date:'EEE, MMM dd, yyyy'}}</option>
                  </ng-container>
                </select>
              </ng-container>
              <div *ngIf="hasError('reportDate', 'required')" role="alert" class="formError text-danger" aria-live="assertive">
                Please, select the report date.
              </div>
              <div *ngIf="hasError('reportDate', 'before')" role="alert" class="formError text-danger" aria-live="assertive">
                Please enter a past date.
              </div>
              <div *ngIf="hasError('reportDate', 'after')" role="alert" class="formError text-danger" aria-live="assertive">
                Report date cannot be before 10/01/2019.
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="reportType">Report Type</label>
              <div class="required-wrapper">
                <select class="form-control required" aria-required="true"
                        id="reportType"
                        formControlName="reportType"
                        aria-label="reportType"
                        [ngClass]="{'is-invalid': hasError('reportType')}"
                        (ngModelChange)="onReportTypeChange($event)"
                        (click)="reportForm.get('reportType').markAsTouched()"
                        [attr.disabled]="isCreationMode ? null : 'disabled'">
                  <option [selected]="isCreationMode && (marketTypes.size != 1)" [disabled]="false" value="">-- Select a Report Type --</option>
                  <option *ngIf="!isCreationMode || marketTypes.has(MarketType.NAQ)" [ngValue]="ReportType.P">Purchase</option>
                  <option *ngIf="!isCreationMode || marketTypes.has(MarketType.AQ)"  [ngValue]="ReportType.PAQ">Purchase-AQ</option>
                </select>
              </div>
              <div *ngIf="hasError('reportType', 'required')" role="alert" class="formError text-danger" aria-live="assertive">
                Please, select the report type.
              </div>
              <div *ngIf="hasError('reportType', 'doesNotMatchMarketType')" role="alert" class="formError text-danger" aria-live="assertive">
                The report type should match market types.
              </div>

            </div>
          </div>
        </div>
        <div *ngIf="hasError('reportType', 'invalidSpecies')" class="alert alert-danger">
          <span>With the change of report types, existing species will need to be removed due to non matching types. Are you sure?</span>
        </div>
        <div *ngIf="showDuplicateWarning" class="alert alert-danger">
          <span *ngIf="showDuplicateWarning && !duplicatesChecking">Another purchase receipt report exists on the same transaction date involving the same licensed fisherman.</span>
        </div>
        <div *ngIf="reportForm.get('seller').value && reportForm.get('reportDate').value && !statusChecking" class="row">
          <div class="col-md-12">
            <div class="card sellerCard" [ngClass]="{'isExpired': LicenseStatus.INACTIVE == sellerStatus}">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <dl class="row mb-0">
                      <dt class="col-sm-6">Fisher Name</dt>
                      <dd class="col-sm-6">{{seller.name}}</dd>
                      <dt class="col-sm-6">Comm. Marine Lic. #</dt>
                      <dd class="col-sm-6">{{seller.licenseNumber}}</dd>
                    </dl>
                  </div>
                  <div [ngSwitch]="sellerStatus" class="col-md-6">
                    <ng-container *ngSwitchCase="LicenseStatus.ACTIVE">
                      <div>
                        <span class="sellerCardHeader">Report Total:</span> <br>
                        <span class="sellerCardValue">{{reportTotal | bigCurrency}}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="LicenseStatus.INACTIVE">
                      <div>
                        <span class="sellerError">
                          The fisher's Commercial Marine License is invalid or expired on the date of purchase.
                          It is prohibited to purchase the marine life offered by this fisher for resale purpose.
                          Please call DAR at (808) 587-0109 for verification and/or questions.
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="seller && (sellerStatus !== null && sellerStatus == LicenseStatus.ACTIVE)">
          <div *ngIf="(reportForm.controls['reportDate'].valid && reportForm.controls['reportType'].value) || !isCreationMode">
            <hr>
            <h2>Purchases</h2>
            <div *ngIf="reportForm.get('purchases').length > 0" class="card">
              <ul class="list-group list-group-flush">
                <li formArrayName="purchases" *ngFor="let purchase of reportForm.get('purchases').controls; let i = index"
                  class="list-group-item">
                  <ng-container [formGroupName]="i">
                    <div class="row">

                      <div class="col-7">
                        <div class="form-group">
                          <app-autocomplete-input
                                              formControlName="species"
                                              (itemSelect)="onSpeciesSelect($event, i)"
                                              (focusin)="selectOnFocus($event)"
                                              (focusOut)="onSpeciesFocusOut($event, i)"
                                              [title]="'Species'"
                                              [editable]="false"
                                              [aria-label]="'species'"
                                              [autocomplete]="speciesAutocomplete"
                                              [inputFormatter]="speciesAutocompleteFormatter"
                                              [resultFormatter]="speciesAutocompleteFormatter"
                                              [isInvalid]="hasArrayError('purchases', i, 'species')">
                          </app-autocomplete-input>
                          <div *ngIf="hasArrayError('purchases', i, 'species', 'required')" role="alert" class="formError text-danger"
                            aria-live="assertive">
                            Please, select correct species.
                          </div>
                          <div *ngIf="hasArrayError('purchases', i, 'species', 'invalidSpecies')" role="alert" class="formError text-danger"
                               aria-live="assertive">
                            Please, enter species that match the report type.
                          </div>

                        </div>
                      </div>

                      <div *ngIf="isConditionNeeded()" class="col-5">
                        <div class="form-group">
                          <app-autocomplete-input formControlName="condition"
                                              (itemSelect)="onConditionSelect($event, i)"
                                              (focusin)="selectOnFocus($event)"
                                              (focusOut)="onConditionFocusOut($event, i)"
                                              [title]="'Condition (OPTIONAL)'"
                                              [editable]="false"
                                              [aria-label]="'condition'"
                                              [autocomplete]="conditionAutocomplete"
                                              [inputFormatter]="conditionAutocompleteFormatter"
                                              [resultFormatter]="conditionAutocompleteFormatter"
                                              [isInvalid]="hasArrayError('purchases', i, 'condition', 'invalidCondition')">
                          </app-autocomplete-input>
                          <div *ngIf="hasArrayError('purchases', i, 'condition', 'invalidCondition')" role="alert" class="formError text-danger"
                               aria-live="assertive">
                            Please, select correct condition.
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="row">

                      <div *ngIf="isLbsBased(i)" class="col-3">
                        <div class="form-group">
                          <label for="purchase-{{i}}-lbs-bought">Lbs. Bought</label>
                          <input type="text" id="purchase-{{i}}-lbs-bought" formControlName="lbsBought" mask="0*.00"
                                 [dropSpecialCharacters]="false"
                                 class="form-control required" aria-required="true" aria-label="quantity pounds bought" (input)="onPurchaseUnitsUpdate(i)"
                                 [ngClass]="{'is-invalid': hasArrayError('purchases', i, 'lbsBought')}">
                          <div *ngIf="hasArrayError('purchases', i, 'lbsBought', 'invalidNumber')" role="alert" class="formError text-danger"
                            aria-live="assertive">
                            Please, enter valid Lbs. Bought.
                          </div>
                          <div *ngIf="hasArrayError('purchases', i, 'lbsBought', 'outOfRange')" role="alert" class="formError text-danger"
                               aria-live="assertive">
                            Entered Lbs. Bought value is outside of allowed range.
                          </div>
                          <div *ngIf="purchaseWarnings['purchase-' + i + '-lbs-bought']" role="alert"
                               class="formError text-danger" aria-live="assertive">
                            Entered Lbs. Bought is outside of typical range
                            (<span *ngIf="!purchaseWarnings['purchase-' + i + '-lbs-bought'].maxWeight">more than </span>{{purchaseWarnings['purchase-' + i + '-lbs-bought'].minWeight}}<span *ngIf="purchaseWarnings['purchase-' + i + '-lbs-bought'].minWeight && purchaseWarnings['purchase-' + i + '-lbs-bought'].maxWeight"> - </span><span *ngIf="!purchaseWarnings['purchase-' + i + '-lbs-bought'].minWeight">less than </span>{{purchaseWarnings['purchase-' + i + '-lbs-bought'].maxWeight}})
                          </div>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="form-group">
                          <label for="purchase-{{i}}-pieces-bought">Pcs. Bought <span *ngIf="!isPcsBased(i) && (!purchase.get('species').value || purchase.get('species').value.pieceExempt)">(OPTIONAL)</span></label>
                          <input type="text" id="purchase-{{i}}-pieces-bought" formControlName="piecesBought" mask='9*'
                                 class="form-control" aria-required="true" aria-label="quanity pieces bought" (input)="onPurchaseUnitsUpdate(i)"
                                 [ngClass]="{'is-invalid': hasArrayError('purchases', i, 'piecesBought')}">
                          <div *ngIf="hasArrayError('purchases', i, 'piecesBought', 'invalidNumber')" role="alert" class="formError text-danger"
                            aria-live="assertive">
                            Please, enter valid Pcs. Bought.
                          </div>
                          <div *ngIf="hasArrayError('purchases', i, 'piecesBought', 'outOfRange')" role="alert" class="formError text-danger"
                               aria-live="assertive">
                            Entered Pcs. Bought value is outside of allowed range.
                          </div>
                        </div>
                      </div>

                      <div *ngIf="isLbsBased(i)" class="col-3">
                        <div class="form-group">
                          <label for="purchase-{{i}}-price-per-lb">Price per Lb. (OPTIONAL)</label>
                          <input type="text" id="purchase-{{i}}-price-per-lb" formControlName="pricePerLb"
                                 appCurrencyInputMask (input)="onPurchaseUnitsUpdate(i)"
                                 (focus)="setInputCursorToEnd($event)" class="form-control" aria-required="true"
                                 aria-label="price per lb"
                                 [ngClass]="{'is-invalid': hasArrayError('purchases', i, 'pricePerLb')}">
                          <div *ngIf="hasArrayError('purchases', i, 'pricePerLb', 'invalidNumber')" role="alert" class="formError text-danger"
                            aria-live="assertive">
                            Please, enter valid Price per Lb.
                          </div>
                          <div *ngIf="hasArrayError('purchases', i, 'pricePerLb', 'outOfRange')" role="alert" class="formError text-danger"
                               aria-live="assertive">
                            Entered Price per Lb. is outside of allowed range.
                          </div>
                          <div *ngIf="purchaseWarnings['purchase-' + i + '-price-per-lb']" role="alert"
                               class="formError text-danger" aria-live="assertive">
                            Entered Price per Lb. is outside of typical range
                            (<span *ngIf="!purchaseWarnings['purchase-' + i + '-price-per-lb'].maxPrice">more than </span>{{purchaseWarnings['purchase-' + i + '-price-per-lb'].minPrice | currency}}<span *ngIf="purchaseWarnings['purchase-' + i + '-price-per-lb'].minPrice && purchaseWarnings['purchase-' + i + '-price-per-lb'].maxPrice"> - </span><span *ngIf="!purchaseWarnings['purchase-' + i + '-price-per-lb'].minPrice">less than </span>{{purchaseWarnings['purchase-' + i + '-price-per-lb'].maxPrice | currency}})
                          </div>
                        </div>
                      </div>

                      <div *ngIf="isPcsBased(i)" class="col-3">
                        <div class="form-group">
                          <label for="purchase-{{i}}-price-per-pc">Price per Pc. (OPTIONAL)</label>
                          <input type="text" id="purchase-{{i}}-price-per-pc" formControlName="pricePerPc"
                                 appCurrencyInputMask (input)="onPurchaseUnitsUpdate(i)" (focus)="setInputCursorToEnd($event)"
                                 class="form-control" aria-required="true" aria-label="price per quantity"
                                 [ngClass]="{'is-invalid': hasArrayError('purchases', i, 'pricePerPc')}" >
                          <div *ngIf="hasArrayError('purchases', i, 'pricePerPc', 'invalidNumber')" role="alert" class="formError text-danger"
                               aria-live="assertive">
                            Please, enter valid Price per Pc.
                          </div>
                          <div *ngIf="hasArrayError('purchases', i, 'pricePerPc', 'outOfRange')" role="alert" class="formError text-danger"
                               aria-live="assertive">
                            Entered Price per Pc. is outside of allowed range.
                          </div>
                          <div *ngIf="purchaseWarnings['purchase-' + i + '-price-per-pc']" role="alert"
                               class="formError text-danger" aria-live="assertive">
                            Entered Price per Pc. is outside of typical range
                            (<span *ngIf="!purchaseWarnings['purchase-' + i + '-price-per-pc'].maxPrice">more than </span>{{purchaseWarnings['purchase-' + i + '-price-per-pc'].minPrice | currency}}<span *ngIf="purchaseWarnings['purchase-' + i + '-price-per-pc'].minPrice && purchaseWarnings['purchase-' + i + '-price-per-pc'].maxPrice"> - </span><span *ngIf="!purchaseWarnings['purchase-' + i + '-price-per-pc'].minPrice">less than </span>{{purchaseWarnings['purchase-' + i + '-price-per-pc'].maxPrice | currency}})
                          </div>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="form-group">
                          <label for="purchase-{{i}}-value">Value</label>
                          <input appCurrencyInputMask type="text" id="purchase-{{i}}-value" formControlName="value" class="form-control" aria-label="value"
                                 [ngClass]="{'is-invalid': hasArrayError('purchases', i, 'value')}" (input)="onPurchaseValueUpdate(i)">
                          <div *ngIf="hasArrayError('purchases', i, 'value', 'required') || hasArrayError('purchases', i, 'value', 'invalidNumber')" role="alert" class="formError text-danger"
                               aria-live="assertive">
                            Please, select correct Value.
                          </div>
                          <div *ngIf="hasArrayError('purchases', i, 'value', 'outOfRange')" role="alert" class="formError text-danger"
                               aria-live="assertive">
                            Entered Value is outside of allowed range.
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div *ngIf="showRemovePurchaseWarning === i" class="alert alert-danger">
                          <span>Are you sure you want to remove purchase? To confirm, click
                            remove again.</span>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <button type="button" *ngIf="reportForm.get('purchases').length > 1" class="btn btn-danger deleteLineButton btn-sm"
                          (click)="removePurchase(i)">
                          <i class="far fa-trash-alt"> </i> Remove
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </li>
              </ul>
            </div>
            <button type="button" class="btn btn-primary btn-sm mt-3" (click)="addPurchase()">
              <i class="fas fa-plus"> </i>&nbsp;Add
            </button>

            <hr>
            <h2>Amendments</h2>
            <div *ngIf="reportForm.get('amendments').length > 0 ; else missing_amendments" class="card">
              <ul class="list-group list-group-flush">
                <li formArrayName="amendments" *ngFor="let amendment of reportForm.get('amendments').controls; let i = index"
                  class="list-group-item">
                  <ng-container [formGroupName]="i">
                    <div class="row">
                      <div class="col-8">
                        <div class="form-group">
                          <label for="amendment-{{i}}-name">Amendment {{i + 1}}</label>
                          <input type="text" id="amendment-{{i}}-name" formControlName="name" class="form-control" aria-required="true"
                            [ngClass]="{'is-invalid': hasArrayError('amendments', i, 'name')}">
                          <div *ngIf="hasArrayError('amendments', i, 'name', 'required')" role="alert" class="formError text-danger"
                            aria-live="assertive">
                            Please, enter amendment name.
                          </div>
                          <div *ngIf="hasArrayError('amendments', i, 'name', 'maxlength')" role="alert" class="formError text-danger" aria-live="assertive">
                            Entered name should have max 250 characters.
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group">
                          <label for="amendment-{{i}}-amount">Amount</label>
                          <input appCurrencyInputMask [negatives]="true" dropSpecialCharacters="false"
                                 (keyup)="updateTotal()" type="text"
                                 id="amendment-{{i}}-amount" formControlName="amount" class="form-control" aria-required="true"
                                 [ngClass]="{'is-invalid': hasArrayError('amendments', i, 'amount')}">
                          <div *ngIf="hasArrayError('amendments', i, 'amount', 'required')" role="alert" class="formError text-danger"
                            aria-live="assertive">
                            Please, enter amendment amount.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div *ngIf="showRemoveAmendmentWarning === i" class="alert alert-danger">
          <span>Are you sure you want to remove amendment? To confirm, click
            remove again.</span>
                        </div>

                        <button type="button" class="btn btn-danger deleteLineButton btn-sm" (click)="removeAmendment(i)">
                          <i class="far fa-trash-alt"> </i> Remove</button>
                      </div>
                    </div>
                  </ng-container>
                </li>
              </ul>
            </div>
            <button type="button" class="btn btn-primary btn-sm mt-3" (click)="addAmendment()">
              <i class="fas fa-plus"> </i> Add
            </button>

            <hr>
            <div class="row">
              <div class="col-md-6">
                <h2>Vessel Info</h2>
                <div class="form-group" formGroupName="vessel">
                  <app-autocomplete-input formControlName="id" (itemSelect)="onVesselSelect($event)"
                                          (input)="onVesselEnter($event)" [id]="'vesselId'"
                                          [title]="vesselRequired || reportForm.get('vessel.name').value ? 'Vessel ID' : 'Vessel ID (OPTIONAL)'" [editable]="true" [aria-label]="'vessel id'"
                                          [aria-label]="'commercial marine licence number'"
                                      [autocomplete]="vesselAutocomplete"
                                      [inputFormatter]="vesselAutocompleteInputFormatter"
                                      [resultFormatter]="vesselAutocompleteResultFormatter"
                                      [isInvalid]="hasError('vessel.id')">
                  </app-autocomplete-input>
                  <div *ngIf="hasError('vessel.id', 'validVesselId')" role="alert" class="formError text-danger" aria-live="assertive">
                    Please, enter a valid Vessel ID.
                  </div>
                  <div *ngIf="hasError('vessel.id', 'required')" role="alert" class="formError text-danger" aria-live="assertive">
                    Please, enter the Vessel ID.
                  </div>
                  <div *ngIf="reportForm.get('vessel.id').value && !hasError('vessel.id') && vesselEnteredManually" class="formError text-warning">
                    <i class="fas fa-info-circle"></i>
                    Please inform the fisherman to add this vessel record in his/her profile in the online fishing report.
                  </div>
                </div>

                <div *ngIf="showBoatNotUsedCheckbox" class="btn-group btn-group-vertical customRadio" data-toggle="buttons">
                  <label class="btn active">
                    <input type="checkbox" (change)="toggleVesselValidation($event)" formControlName="boatNotUsed">
                    <i class="far fa-square fa-2x" ></i><i class="far fa-check-square fa-2x"></i>
                    <span> Did not use vessel, but other craft type.</span>
                  </label>
                </div>

                <div class="form-group" formGroupName="vessel">
                    <label for="vesselName">Vessel Name (OPTIONAL)</label>
                    <input type="text" id="vesselName" formControlName="name" class="form-control" aria-label="vessel name"
                           [ngClass]="{'is-invalid': hasError('vessel.name')}" (input)="onVesselNameEnter()" >
                    <div *ngIf="hasError('vessel.name', 'required') || hasError('vessel.name', 'notBlank')" role="alert" class="formError text-danger" aria-live="assertive">
                      Please, enter the Vessel Name.
                    </div>
                    <div *ngIf="hasError('vessel.name', 'maxlength') || hasError('vessel.name', 'fitInto')" role="alert" class="formError text-danger" aria-live="assertive">
                      Vessel Name should have max 250 characters.
                    </div>
                </div>
              </div>

              <div class="col-md-6">
                <h2>Remarks</h2>
                <div class="form-group">
                  <label for="remarks">Add comments for this (OPTIONAL)</label>
                  <textarea id="remarks" class="form-control" formControlName="remarks" rows="5"
                            [ngClass]="{'is-invalid': hasError('remarks')}"></textarea>
                  <div *ngIf="hasError('remarks', 'maxlength') || hasError('remarks', 'fitInto')" role="alert" class="formError text-danger" aria-live="assertive">
                    Entered remarks should have max 1000 characters.
                  </div>
                  <div *ngIf="hasError('remarks', 'pattern')" role="alert" class="formError text-danger" aria-live="assertive">
                    Entered remarks should not have returns or double quotes.
                  </div>
                </div>
              </div>
            </div>
            <hr>

            <div class="btn-group btn-group-vertical customRadio" data-toggle="buttons">
              <label *ngIf="isCreationMode" class="btn active email-receipt">
                <input type="checkbox" formControlName="notifyFisher" >
                <i class="far fa-square fa-2x" ></i><i class="far fa-check-square fa-2x"></i>
                <span> Send email receipt to fisher</span>
              </label>

              <label *ngIf="!isCreationMode" class="btn email-receipt disabled">
                <i class="far fa-square fa-custom" ></i>
                <span> Send email receipt to fisher</span>
              </label>
            </div>
          </div>
        </div>
        <div *ngIf="showCancelWarning" class="alert alert-danger">
          <span *appHasAuthority="'MANAGE_MY_REPORT'">
            Are you sure you want to close the screen without saving or submitting the input? To confirm, click
            cancel again.
          </span>
          <span *appHasAuthority="'DEALER_INFO'">
            Are you sure you want to abort this action? Otherwise, nothing will be saved or submitted.
          </span>
        </div>
      </div>
      <div class="modal-footer">
        <div class="reportDate float-left" ng-class="{'adminReportDate': config.type === 'admin'}">
          <strong *ngIf="reportForm.controls['reportDate'].valid">Report Date:
            {{reportForm.controls['reportDate'].value | toDate | date:'longDate'}}
          </strong>
        </div>
        <div>
          <button *ngIf="isCreationMode && !loading" type="button" (click)="submitAndContinue();" [disabled]="!submitActive"
            class="btn-xs-block btn btn-primary btn mr-1">
            <i class="fas fa-check"> </i>&nbsp;Submit &amp; Continue
          </button>
          <button *ngIf="!loading" type="submit" [disabled]="!submitActive"
            class="btn-xs-block btn btn-primary btn mr-1">
            <i class="fas fa-check"> </i>&nbsp;Submit
          </button>

          <i *ngIf="loading" class="fa fa-spinner fa-spin"></i>

          <button class="btn-xs-block btn btn-secondary" type="button" (click)="onCancel()">
            <i class="fas fa-times"> </i>&nbsp;Cancel
          </button>
        </div>

      </div>
    </form>
  </div>
</div>

<ng-template #purchase_date_picker>
  <ng-container [formGroup]="reportForm">
    <label for="date">Date</label>
    <div class="input-group">
      <input
        type="text"
        id="date"
        formControlName="reportDate"
        placeholder="mm/dd/yyyy"
        class="form-control"
        aria-required="true"
        ngbDatepicker
        #d="ngbDatepicker"
        [firstDayOfWeek]="7"
        [showWeekNumbers]="true"
        [navigation]="'arrows'"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [ngClass]="{'is-invalid': hasError('reportDate')}">
      <div class="input-group-append" (click)="d.toggle()" (keydown.enter)="d.toggle()"
           (keydown.space)="d.toggle(); $event.preventDefault()" role="button" tabindex="0"
           aria-label="Open date picker">
        <span class="input-group-text"><i class="fas fa-calendar"></i></span>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #missing_amendments>
  <div>
    <p>Add amendments such as tax charged or freight deduction.</p>
  </div>
</ng-template>
